const styles = theme => ({
  collectionGalleryView: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '16px',
    overflow: 'hidden',
    gap: '20px',
    height: '320px',
    transition: 'all 0.3s ease-in-out',
    padding: '8px',
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.20), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
    cursor: 'pointer',
  },
  coverImage: {
    height: '160px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    cursor: 'pointer',
    position: 'relative',
    borderRadius: '12px',
  },
  collectionName: {
    whiteSpace: 'normal',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '14px',
    height: '44px',
    fontWeight: 500,
  },
  collectionInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '0px 8px 8px 8px',
  },
  courseCount: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  courseCountBadge: {
    borderRadius: '6px',
    background: '#E3F3FF',
    padding: '4px 8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  courseCountText: {
    fontSize: '12px',
    color: '#015FFB',
    fontWeight: 500,
  },
  courseCountIcon: {
    color: '#838D98',
    fontSize: '20px',
  },
})

export default styles
